const LAUNCH_COMPANY_STORAGE_KEY = "admin.launchRequestedCompanyId";

/** Remember org chosen on Ask Aya My Apps so Admin must not auto-switch away. */
export function setLaunchRequestedCompanyId(companyId: string): void {
  const id = companyId?.trim();
  if (!id || typeof sessionStorage === "undefined") {
    return;
  }
  try {
    sessionStorage.setItem(LAUNCH_COMPANY_STORAGE_KEY, id);
  } catch {
    /* ignore quota / private mode */
  }
}

export function getLaunchRequestedCompanyId(): string | null {
  if (typeof sessionStorage === "undefined") {
    return null;
  }
  try {
    return sessionStorage.getItem(LAUNCH_COMPANY_STORAGE_KEY)?.trim() || null;
  } catch {
    return null;
  }
}

export function clearLaunchRequestedCompanyId(): void {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  try {
    sessionStorage.removeItem(LAUNCH_COMPANY_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function shouldSkipPreferredCompanyAutoSelect(): boolean {
  return !!getLaunchRequestedCompanyId();
}

export function isActiveLaunchRequestedCompany(
  companyId: string | null | undefined
): boolean {
  const requested = getLaunchRequestedCompanyId();
  if (!requested || !companyId?.trim()) {
    return false;
  }
  return requested.toLowerCase() === companyId.trim().toLowerCase();
}
